import { NgModule } from '@angular/core';
import { EnterTheViewPortDirective } from './enter-the-view-port.directive';
import { ClickOutsideDirective } from './click-outside.directive';

@NgModule({
  declarations: [EnterTheViewPortDirective],
  exports: [EnterTheViewPortDirective],
})
export class DirectivesModule {}
